import { useEffect } from "react";
import AuburnHeroSection from "./components/HeroSection";
import AuburnStickyNav from "./components/StickyNav";
import AuburnProcessingTimeSection from "./components/ProcessingTimeSection";
import AuburnServicesSection from "./components/ServicesSection";
import AuburnLocalAreaSection from "./components/LocalAreaSection";
import AuburnTravelTimingSection from "./components/TravelTimingSection";
import AuburnDestinationsSection from "./components/DestinationsSection";
import AuburnTestimonialsSection from "./components/TestimonialsSection";
import AuburnAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AuburnComparisonSection from "./components/ComparisonSection";
import AuburnMistakesSection from "./components/MistakesSection";
import AuburnHowItWorksSection from "./components/HowItWorksSection";
import AuburnFAQSection, { faqs } from "./components/FAQSection";
import AuburnHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AuburnFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function AuburnPage() {
  useEffect(() => {
    document.title = "Emergency Passport Auburn AL — Expedited Same-Day Service | Fast Passport Center";
    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };
    const pageUrl = "https://fastpassportcenter.com/auburn/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Auburn, AL — as fast as 24 hours. Auburn University students, faculty, and Lee County residents served. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Auburn, Alabama");
    setMeta("geo.region", "US-AL");
    setMeta("geo.position", "32.6099;-85.4808");
    setMeta("ICBM", "32.6099, -85.4808");
    const graph = [
      { "@type": "BreadcrumbList", itemListElement: [{ "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" }, { "@type": "ListItem", position: 2, name: "Alabama", item: "https://fastpassportcenter.com/alabama/" }, { "@type": "ListItem", position: 3, name: "Auburn Passport Services", item: pageUrl }] },
      { "@type": "LocalBusiness", name: "Fast Passport Center", description: "Emergency and expedited passport services for Auburn and Lee County, Alabama — as fast as 24 hours.", url: pageUrl, telephone: "+1-877-253-0084", areaServed: { "@type": "City", name: "Auburn", containedInPlace: { "@type": "State", name: "Alabama" } }, priceRange: "$$$", openingHours: ["Mo-Fr 09:00-18:00"], aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" } },
      { "@type": "FAQPage", mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })) },
    ];
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-auburn";
    document.getElementById("structured-data-auburn")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);
    return () => { document.getElementById("structured-data-auburn")?.remove(); const canonical = document.querySelector('link[rel="canonical"]'); if (canonical) canonical.remove(); };
  }, []);

  return (
    <div className="font-sans">
      <AuburnHeroSection />
      <AuburnStickyNav />
      <AuburnProcessingTimeSection />
      <AuburnServicesSection />
      <AuburnLocalAreaSection />
      <AuburnTravelTimingSection />
      <AuburnDestinationsSection />
      <AuburnTestimonialsSection />
      <AuburnAcceptanceFacilitiesSection />
      <AuburnComparisonSection />
      <AuburnMistakesSection />
      <AuburnHowItWorksSection />
      <AuburnFAQSection />
      <AuburnHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/auburn" state="AL" />
      <AuburnFinalCTA />
    </div>
  );
}